import { createFacilityApiClient } from "../lib/apiClient";

const api = createFacilityApiClient();

export const fetchFacilities = () => api.get("/facilities");

export const fetchFacility = ({ queryKey }) => {
  const facilityId = queryKey[1];
  return api.get(`/facilities/${facilityId}`);
};

export const fetchFacilitiesByOrganisationId = ({ queryKey }) => {
  const organisationId = queryKey[2];
  return api.get(`/facilities/organisation/${organisationId}`);
};

export const createFacility = (facilityData) =>
  api.post("/facilities", facilityData);

export const updateFacility = (facilityId, facilityData) =>
  api.put(`/facilities/${facilityId}`, facilityData);

export const deleteFacility = (facilityId) => {
  if (facilityId === undefined) {
    return undefined;
  }
  return api.delete(`/facilities/${facilityId}`);
};
